var FIGURE = FIGURE || {};

FIGURE.shippingMessage = function() {
	var specialMessageModal = $.cookie('specialmessage');
	if (specialMessageModal == 'read') {
		return;
	} else {
		setTimeout(function(){
			$('#figureMessageModal').modal();
		}, 3000);	
	}	
	$('#figureMessageModal').on('hide.bs.modal', function (event) {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
	$('#figureMessageModal a').click(function() {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
}();

FIGURE.logoSlider = (function() {

	function init() {
		const sliders = document.querySelectorAll('.logo-slider');
		sliders.forEach(slider => {
			const slides = slider.querySelector('.logo-slides');
			if (!slides) return;

			// Wait for images to load before measuring overflow
			const images = slides.querySelectorAll('img');
			if (images.length) {
				const imagePromises = Array.from(images).map(img => {
					if (img.complete) return Promise.resolve();
					return new Promise(resolve => {
						img.addEventListener('load', resolve);
						img.addEventListener('error', resolve); // don't block on broken images
					});
				});
				Promise.all(imagePromises).then(() => setup(slider, slides));
			} else {
				setup(slider, slides);
			}
		});
	}

	function setup(slider, slides) {
		if (slides.scrollWidth <= slides.clientWidth) return;
		initDrag(slides);
		initAutoScroll(slider, slides);
	}

	function initDrag(slides) {
		let isDown = false;
		let startX;
		let scrollLeft;

		// Prevent image drag interfering
		slides.querySelectorAll('img').forEach(img => {
			img.setAttribute('draggable', 'false');
			img.addEventListener('dragstart', e => e.preventDefault());
		});

		slides.addEventListener('mousedown', (e) => {
			isDown = true;
			slides.classList.add('is-dragging');
			startX = e.pageX - slides.offsetLeft;
			scrollLeft = slides.scrollLeft;
			e.preventDefault(); // prevent text/image selection
		});

		// mouseup/mousemove on document so drag doesn't break if cursor leaves slides
		document.addEventListener('mouseup', () => {
			if (!isDown) return;
			isDown = false;
			slides.classList.remove('is-dragging');
		});

		document.addEventListener('mousemove', (e) => {
			if (!isDown) return;
			e.preventDefault();
			const x = e.pageX - slides.offsetLeft;
			const walk = (x - startX) * 1.5;
			slides.scrollLeft = scrollLeft - walk;
		});

		slides.addEventListener('touchstart', (e) => {
			startX = e.touches[0].pageX - slides.offsetLeft;
			scrollLeft = slides.scrollLeft;
		}, { passive: true });

		slides.addEventListener('touchmove', (e) => {
			const x = e.touches[0].pageX - slides.offsetLeft;
			const walk = (x - startX) * 1.5;
			slides.scrollLeft = scrollLeft - walk;
		}, { passive: true });
	}

	function initAutoScroll(slider, slides) {
		let autoScrollInterval = null;
		let delay = null;
		let userInteracting = false;

		const stopAutoScroll = () => {
			clearInterval(autoScrollInterval);
			autoScrollInterval = null;
		};

		const scheduleAutoScroll = () => {
			clearTimeout(delay);
			delay = setTimeout(() => {
				if (!userInteracting) startAutoScroll();
			}, 8000);
		};

		const startAutoScroll = () => {
			if (autoScrollInterval) return;
			console.log({
				scrollLeft: slides.scrollLeft,
				clientWidth: slides.clientWidth,
				scrollWidth: slides.scrollWidth
			});
			autoScrollInterval = setInterval(() => {
				if (slides.scrollLeft + slides.clientWidth >= slides.scrollWidth - 1) {
					slides.scrollTo({ left: 0, behavior: 'smooth' });
				} else {
					slides.scrollBy({ left: 300, behavior: 'smooth' });
				}
			}, 4500);
		};

		slides.addEventListener('mousedown', () => {
			userInteracting = true;
			stopAutoScroll();
		});

		document.addEventListener('mouseup', () => {
			if (!userInteracting) return;
			userInteracting = false;
			scheduleAutoScroll();
		});

		slides.addEventListener('touchstart', () => {
			userInteracting = true;
			stopAutoScroll();
		}, { passive: true });

		slides.addEventListener('touchend', () => {
			userInteracting = false;
			scheduleAutoScroll();
		}, { passive: true });

		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					scheduleAutoScroll();
				} else {
					stopAutoScroll();
					clearTimeout(delay);
				}
			});
		}, { threshold: 0.25 }); // lowered from 0.5

		observer.observe(slider);
	}
	init();
	// return { init };

}());

FIGURE.groupSelectionValidation = function() {

	function init() {
		const checkboxes = document.querySelectorAll('.group-selection-check');
		if (!checkboxes.length) return;

		checkboxes.forEach(cb => cb.addEventListener('change', validate));
	}

	function validate() {
		const checkboxes = document.querySelectorAll('.group-selection-check');
		const hiddenInput = document.getElementById('group_ids_valid');
		const error = document.getElementById('group-ids-error');
		const anyChecked = Array.from(checkboxes).some(cb => cb.checked);

		hiddenInput.value = anyChecked ? 'valid' : '';
		error.style.setProperty('display', anyChecked ? 'none' : 'block', 'important');
	}

	init();

}();

FIGURE.changeAddFullOfferingBtnText = function() {
	$(".add-your-full-allocation-button .btn").text("Add Full Allocation To Cart");
	$(".add-your-full-allocation-button .btn").css("opacity", 1);
}();
